export const cleanDocument = (value) => String(value ?? "").replace(/\D/g, "")

export const getRootCnpj = (value) => {
    const cleaned = cleanDocument(value)
    return cleaned.length >= 8 ? cleaned.slice(0, 8) : cleaned
}

export const getCnpjRoot = (value) => {
    if (!value) return null

    const cnpj = cleanDocument(value)
    return cnpj.length === 14 ? cnpj.slice(0, 8) : null
}